// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1InvoiceSchema } from './v1/invoiceSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const showInvoicePathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  id: z.number().int().describe("Invoice ID"),
});

export const showInvoiceHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Invoice details
 */
export const showInvoice200Schema = z.lazy(() => v1InvoiceSchema);

/**
 * @description Unauthorized
 */
export const showInvoice401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Invoice not found
 */
export const showInvoice404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const showInvoiceQueryResponseSchema = z.lazy(() => showInvoice200Schema);
